import { Component, OnInit } from '@angular/core';
import { Form, NgForm } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import { UserProfileState } from '@state/user-profile';
import { UserProfileDispatch } from '@state/user-profile/dispatch';
import { Observable } from 'rxjs';

@UntilDestroy()
@Component({
	selector: 'app-teranet-username',
	templateUrl: './username.component.html',
	standalone: false,
})
export class TeranetUsernameComponent implements OnInit {
	public ternaetUserForm: Form;
	public teranetUsernameFormValue = 'teranetUserName';
	public teranetUsername;
	public savedInitialUsername;

	@Select(UserProfileState.getTeranetUsername)
	teranetUsername$: Observable<string>;

	constructor(private userProfileDispatch: UserProfileDispatch) {}

	ngOnInit(): void {
		this.teranetUsername$.pipe(untilDestroyed(this)).subscribe((value) => {
			this.savedInitialUsername = value;
			this.teranetUsername = value;
		});
	}

	onSubmit(form: NgForm) {
		if (form.invalid) {
			return;
		}

		this.userProfileDispatch.SetTeranetUsername(this.teranetUsername);
	}
}
